import { useEffect } from 'react'
import { useMap } from '@vis.gl/react-google-maps'

type props = {
  boundary: any,
  options: object,
  zIndex?: number
}

export const Boundary = ({boundary, options, zIndex = 1}: props) => {

  const map = useMap()

  useEffect(() => {
    if (!boundary) return

    const polygon = new window.google.maps.Polygon({
      paths: boundary,
      ...options,
      zIndex
    })


    polygon.setMap(map)

    return () => { polygon.setMap(null)}

  }, [boundary])
}
